import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Col, CardBody, Button } from "reactstrap";
import { reduxForm } from "redux-form";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { createTheme } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/styles";
import SearchIcon from "@material-ui/icons/Search";
import history from "../../../../../history";
import TextField from "@material-ui/core/TextField";
import "moment/locale/es";
import { formatNumber } from "../../../../Utils/Money";
import ElectronicBillingHTTP from "../../../../ElectronicBilling/api/ElectronicBillingHTTP";
import CreditNoteNotTransmited from "./CreditNoteNotTransmited";
import { DataGrid } from "@mui/x-data-grid";
import { Input } from "reactstrap";
import { useAsyncDebounce } from "react-table";
import ReactTableActions from "./ReactTableActions";

const defaultTheme = createTheme();
export const StyledDataGrid = withStyles({
  root: {
    
    "& .MuiDataGrid-cell": {
      textWrap: "wrap",
      lineHeight: "unset !important",
      maxHeight: "none !important",
      padding: '10px 10px !important'
    },
    "& .MuiDataGrid-renderingZone": {
      maxHeight: "none !important",
      height: "100% !important",
      overflowY: "scroll",
      overflowX:"hidden"
    },
    "& .MuiDataGrid-row": {
      maxHeight: "none !important",
    },
    "& .MuiDataGrid-window" :{
      overflow: "hidden !important",
    }
  },
})(DataGrid);

const renderField = ({
  input,
  disabled,
  placeholder,
  type,
  meta: { touched, error },
  style,
}) => (
  <div
    className="form__form-group-input-wrap form__form-group-input-wrap--error-above"
    style={style}
  >
    <input
      {...input}
      placeholder={placeholder}
      type={type}
      disabled={disabled}
    />
    {touched && error && (
      <span className="form__form-group-error">{error}</span>
    )}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: "",
  meta: null,
  type: "text",
};

const SearchCreditNotes = () => {
  let clinica = JSON.parse(sessionStorage.getItem("clinica"));
  const [dates, setDates] = useState({ start: new Date(), end: new Date() });
  const [costumer, setCostumer] = useState("");
  const [costumers, setCostumers] = useState([]);
  const [invoices, setInvoices] = useState([]); //{ id: '1', fac_num: '1', nit: '123456789', cliente: 'IPS del Mar', fecha: moment(new Date()).format("YYYY/MM/DD"), valor: '120000' }
  const [errors, setErrors] = useState({});
  const [retentionsTypeList, setRetentionsTypeList] = useState([]);
  const [electronicInvoiceProvider, setElectronicInvoiceProvider] =
    useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);

  useEffect(() => {
    loadCostumer();
    listInvoice();
    getRetentionsType();
    actualProvider();
  }, []);

  const actualProvider = async () => {
    let actualProvider = await ElectronicBillingHTTP.getActualProvider();
    setElectronicInvoiceProvider(actualProvider);
  };

  const loadCostumer = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "tercero/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setCostumers(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const validateSearch = () => {
    var errors = {};

    if (moment(dates.end).diff(dates.start) < 0) {
      errors.date = "Ingrese fechas adecuadas";
    } else {
      delete errors.date;
    }

    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      return false;
    } else {
      return true;
    }
  };

  const getRetentionsType = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "tipo-retencion/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error(response.json());
        }
      })
      .then((data) => {
        setRetentionsTypeList(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const searchInvoice = () => {
    if (!validateSearch()) {
      listInvoice();
      /* let data = {};

      data = {
        id_tercero: costumer,
        desde: moment(dates.start).format("YYYY/MM/DD"),
        hasta: moment(dates.end).format("YYYY/MM/DD"),
      };

      fetch(process.env.REACT_APP_PUBLIC_URL + "facturas/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            filterData(data.contenido);
          } else {
            setInvoices([]);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        }); */
    }
  };

  const listInvoice = async () => {
    let url =
      process.env.REACT_APP_PUBLIC_URL +
      `facturas/listar?page=${page + 1}&page_size=${pageSize}`;
    if (search) {
      url += `&search=${search}`;
    } else {
      if (costumer) {
        url += `&id_tercero=${costumer}`;
      }
      url += `&start_date=${moment(dates.start).format(
        "YYYY/MM/DD"
      )}&end_date=${moment(dates.end).format("YYYY/MM/DD")}`;
    }

    await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setRowCount(data.count);
        if (data.results.length > 0) {
          filterData(data.results);
        } else {
          setInvoices([]);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const filterData = (data) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].factura_salud && data[i].tipo != 1) {
        try {
          let total = 0;
          data[i].servicios.recibos_caja.map((item, index) => {
            total = parseInt(total) + parseInt(item.valor_tercero);
          });
          data[i].total_factura = total;
        } catch (e) {
          data[i].total_factura = data[i].total;
        }
      } else {
        data[i].total_factura = parseInt(data[i].total);
      }
    }
    setInvoices(data);
  };

  const Callback = () => {
    listInvoice();
  };

  const loadBilling = (id_admision) => {
    return new Promise((resolve, reject) => {
      var dataBilling = { id_admision: parseInt(id_admision) };
      fetch(process.env.REACT_APP_PUBLIC_URL + "reciboscaja/admisionpaga", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataBilling),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data.contenido[0]);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  };

  const calculateTotal = (invoice) => {
    let total_tercero = 0;
    let total_abonos = 0;
    if (invoice.hasOwnProperty("servicios")) {
      //Factura en salud
      if (invoice.servicios !== null && invoice.servicios !== undefined) {
        if (invoice.tipo !== null) {
          if (invoice.tipo === 1) {
            // cuando es particular el total de la factura es el total del copago
            if (invoice.servicios.recibos_caja.length > 0) {
              invoice.servicios.recibos_caja.forEach((recibo) => {
                total_tercero += parseInt(recibo.total);
                total_abonos = 0;
              });
            }
          } else {
            // cuando es otro regimen
            if (invoice.servicios.recibos_caja.length > 0) {
              invoice.servicios.recibos_caja.forEach((recibo) => {
                total_tercero += parseInt(recibo.valor_tercero);
                total_abonos += parseInt(recibo.total);
              });
            }
          }
        }
      } else if (invoice.hasOwnProperty("detalles_comerciales")) {
        //Factura Comercial
        total_tercero = parseInt(invoice.detalles_comerciales?.total);
        total_abonos = parseInt(invoice.detalles_comerciales?.copago);
      } else {
        total_tercero = 0;
        total_abonos = 0;
      }
    }
    return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos };
  };

  const defineTotalInvoice = (invoice) => {
    let calculateInvoiceTotals = calculateTotal(invoice);
    let totalInvoice = 0;
    //Si la factura es particular
    if (
      invoice.tipo === 1 &&
      calculateInvoiceTotals !== null &&
      calculateInvoiceTotals !== undefined
    ) {
      totalInvoice = calculateInvoiceTotals?.total_tercero;
    } else {
      // si la factura es de un tercero
      totalInvoice = calculateInvoiceTotals.total_tercero;
    }
    return totalInvoice;
  };

  const columns = [
    {
      field: "num_fac_ter",
      headerName: "DOCS N°",
      width: 82,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "fecha_emision",
      headerName: "FECHA EMISION",
      type: "date",
      width: 86,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) => moment(params.value).format("YYYY/MM/DD"),
    },
    {
      field: "vencimiento",
      headerName: "FECHA VENCIMIENTO",
      type: "date",
      width: 113,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) => moment(params.value).format("YYYY/MM/DD"),
    },
    {
      field: "factura_tipo_fe",
      headerName: "TIPO DE FACTURA",
      type: "string",
      width: 95,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "folio_nota_credito",
      headerName: "NOTA CRÉDITO",
      width: 82,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null ? params.value : "No Aplica",
    },
    {
      field: "nombre_facturado",
      headerName: "CLIENTE",
      type: "string",
      width: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "num_documento",
      headerName: "DOCUMENTO",
      type: "string",
      width: 125,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "documento_paciente_facturado",
      headerName: "DOCUMENTO DEL PACIENTE",
      type: "string",
      width: 115,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "nombre_paciente_facturado",
      headerName: "NOMBRE DEL PACIENTE",
      type: "string",
      width: 180,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "total_factura",
      headerName: "TOTAL",
      type: "number",
      width: 90,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) => `$${formatNumber(params.value)}`,
    },
    {
      field: "actions",
      headerName: "ACCIONES",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,

      renderCell: (params) => {
        const fechaInicial = moment(dates.start).format("YYYY/MM/DD");
        const fechaFinal = moment(dates.end).format("YYYY/MM/DD");
        return ReactTableActions({
          data: params.row,
          Callback,
          fechaInicial,
          fechaFinal,
          loadBilling,
          retentionsTypeList,
          electronicInvoiceProvider,
          costumers,
        });
      },
    },
  ];

  const columnsOld = [
    {
      field: "num_fac_ter",
      headerName: "DOCS N°",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "fecha_emision",
      headerName: "FECHA EMISION",
      type: "date",
      width: 200,

      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) => moment(params.value).format("YYYY/MM/DD"),
    },
    {
      field: "vencimiento",
      headerName: "FECHA VENCIMIENTO",
      type: "date",
      width: 200,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) => moment(params.value).format("YYYY/MM/DD"),
    },
    {
      field: "factura_tipo_fe",
      headerName: "TIPO DE FACTURA",
      type: "string",
      width: 200,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "folio_nota_credito",
      headerName: "NOTA CRÉDITO",
      width: 180,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null ? params.value : "No Aplica",
    },
    {
      field: "nombre_facturado",
      headerName: "CLIENTE",
      type: "string",
      width: 250,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "num_documento",
      headerName: "DOCUMENTO",
      type: "string",
      width: 180,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "total_factura",
      headerName: "TOTAL",
      type: "number",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) => `$${formatNumber(params.value)}`,
    },
    {
      field: "actions",
      headerName: "ACCIONES",
      width: 500,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        const fechaInicial = moment(dates.start).format("YYYY/MM/DD");
        const fechaFinal = moment(dates.end).format("YYYY/MM/DD");
        return ReactTableActions({
          data: params.row,
          Callback,
          fechaInicial,
          fechaFinal,
          loadBilling,
          retentionsTypeList,
          electronicInvoiceProvider,
          costumers,
        });
      },
    },
  ];

  useEffect(() => {
    listInvoice();
  }, [search, page, pageSize, dates]);

  const onChange = useAsyncDebounce((item) => {
    setSearch(item || undefined);
    setPage(0);
  }, 200);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const RenderTableInvoices = () => {
    return (
      <div>
        <div style={{ display: "flex", height: 500 }}>
          <div style={{ flexGrow: 1 }}>
            <StyledDataGrid
              style={{ fontSize: "12px" }}
              title={"Documentos Clientes"}
              columns={clinica.factura_ver_mas ? columns : columnsOld}
              rows={invoices}
              getRowId={(row) => row.num_fac_ter}
              filterMode="server"
              pagination
              paginationMode="server"
              rowCount={rowCount}
              pageSize={pageSize}
              rowsPerPageOptions={[10, 50, 100]}
              page={page}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <CardBody>
        <form className="material-form">
          <Col>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <TextField
                className="material-form__field"
                label="Cliente"
                id="id-simple-select"
                //className="material-form__field"
                style={{ width: 300 }}
                select
                value={costumer}
                onChange={(e) => setCostumer(e.target.value)}
              >
                {costumers.map((costumer) => {
                  return (
                    <MenuItem
                      className="material-form__option"
                      key={costumer.id_tercero}
                      value={costumer.id_tercero}
                    >
                      {costumer.nombre}
                    </MenuItem>
                  );
                })}
              </TextField>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  disableFuture
                  label="Fecha desde"
                  className="material-form__field"
                  style={{ width: 300, marginLeft: 20, marginTop: 5 }}
                  value={dates.start}
                  onChange={(date) => {
                    setDates({ ...dates, start: date });
                  }}
                  animateYearScrolling
                  autoOk={true}
                  format="yyyy/MM/D"
                />
                <DatePicker
                  disableFuture
                  label="Fecha hasta"
                  className="material-form__field"
                  style={{ width: 300, marginLeft: 20, marginTop: 5 }}
                  value={dates.end}
                  onChange={(date) => {
                    setDates({ ...dates, end: date });
                  }}
                  animateYearScrolling
                  format="yyyy/MM/D"
                  autoOk={true}
                />
              </MuiPickersUtilsProvider>
            </div>
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div style={{ marginTop: 20 }}>
              <Button
                style={{}}
                size="sm"
                color="primary"
                onClick={() => {
                  searchInvoice();
                }}
              >
                <SearchIcon />
              </Button>
              <Button
                style={{ marginLeft: 20 }}
                size="sm"
                color="primary"
                onClick={() => {
                  history.push({
                    pathname:
                      process.env.PUBLIC_URL + "/billing/add-invoice-costumer",
                    state: { numNota: 0, esFactura: true },
                  });
                }}
              >
                Agregar Factura
              </Button>
              <Button
                style={{ marginLeft: 20 }}
                size="sm"
                color="primary"
                onClick={() => {
                  history.push({
                    pathname:
                      process.env.PUBLIC_URL + "/billing/add-invoice-costumer",
                    state: { numNota: 0, esFactura: false },
                  });
                }}
              >
                Agregar Cuenta de Cobro
              </Button>
            </div>
            <CreditNoteNotTransmited />
          </Col>
        </form>
        <Col>
          <Input
            className="table__search table__search-input"
            value={search}
            style={{ width: "20%" }}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            placeholder={`Buscar...`}
          />
          <RenderTableInvoices />
        </Col>
      </CardBody>
    </>
  );
};
export default reduxForm({
  form: "search_cretit_note_form", // a unique identifier for this form
})(SearchCreditNotes);
